import { stringify } from 'qs';
import { getParams } from './history';

export const doHref = (params, noPrefix = false) => {
  const { order, view } = getParams();
  const pa = {};

  const e = { ...{ order, view }, ...params };

  for (var k in e) {
    if (!e[k]) continue;
    pa[k] = e[k];
  }

  return (!noPrefix ? '#/' : '') + stringify(pa);
};
